import { FormHelperTextClassKey } from '@material-ui/core/FormHelperText';

const MuiFormHelperText = (): Partial<Record<FormHelperTextClassKey, unknown>> => ({
    /* Styles applied to the root element. */
    root: {
        alignItems: 'center',
        display: 'flex',
        fontWeight: 400,
        '& > svg': {
            fontSize: '1rem',
            marginRight: 4,
        },
    },
    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
        marginLeft: 24,
        marginRight: 24,
    },
});

export default MuiFormHelperText;
